<div class="position-relative h-100 w-100">
  @if (!inPinState()) {
    <div class="d-flex flex-column surface-back radius-medium py-pony px-medium">
      <a
        class="group-list-item"
        (click)="handleChangePin()"
      >
        <span class="text-onback-low b-2">تغییر رمز عبور</span>
        <common-icon-dp-icon
          [iconSize]="'16'"
          [classes]="'text-onback-low'"
          [icon]="'arrow-2-left'"
          [iconType]="'linear'"
        ></common-icon-dp-icon>
      </a>
      <hr class="divider border-t-100 border-color-light" />
      <a
        class="group-list-item"
        (click)="inDeletePasswordState.set(true)"
      >
        <span class="text-onback-low b-2">حذف رمز عبور</span>
        <common-icon-dp-icon
          [iconSize]="'16'"
          [classes]="'text-onback-low'"
          [icon]="'arrow-2-left'"
          [iconType]="'linear'"
        ></common-icon-dp-icon>
      </a>
    </div>

    <p class="text-onback-high st-8 mt-huge mb-small">استفاده از رمز برای</p>
    <div class="d-flex flex-column surface-back radius-medium py-pony px-medium">
      <a class="group-list-item">
        <span class="text-onback-low b-2">پرداخت با کیف پول</span>
        @if (initialized()) {
          <ui-form-field
            type="slide-toggle"
            [(ngModel)]="payWalletWithPin"
            (change)="setUserFeature()"
          ></ui-form-field>
        } @else {
          <lib-ngx-skeleton-loading
            width="40px"
            height="20px"
          ></lib-ngx-skeleton-loading>
        }
      </a>
    </div>
    <p class="text-onback-low l-2 pt-small pb-big">
      در صورت خاموش بودن این گزینه، رمز عبور جهت ورود به دیجی‌پی و صفحه رمز عبور استفاده می‌شود.
    </p>
    @if (isBiometricAvailable()) {
      <div class="d-flex align-items-center w-100 radius-medium py-pony px-medium surface-back">
        <a class="group-list-item w-100">
          <span class="text-onback-low b-2">ورود هوشمند دیجی‌پی</span>
          <ui-form-field
            type="slide-toggle"
            [(ngModel)]="hasBiometric"
            (change)="handleBiometric()"
          ></ui-form-field>
        </a>
      </div>
      <p class="l-2 pt-pony text-onback-low">برای ورود سریع‌تر به دیجی‌پی، می‌توانید از اثر انگشت یا تشخیص چهره دستگاه خود استفاده کنید.</p>
    }
    @if (inDeletePasswordState()) {
      <div class="delete-password-modal">
        <div class="delete-password-modal-buttons">
          <ngx-button
            (clickHandler)="deletePassword()"
            [style]="'tinted-on-back'"
            [destructive]="true"
            [fullWidth]="true"
            [size]="'large'"
          >
            حذف رمز عبور
          </ngx-button>
          <ngx-button
            (clickHandler)="inDeletePasswordState.set(false)"
            [style]="'tinted-on-elevated'"
            [size]="'large'"
            [fullWidth]="true"
          >
            انصراف
          </ngx-button>
        </div>
      </div>
    }
  } @else {
    <common-pin-layout
      [pinConfig]="{
        newPasswordType: true,
        type: true,
      }"
      (callbackFunction)="pinCallback()"
    ></common-pin-layout>
  }
</div>
